import React from "react";

import { Box } from "@material-ui/core";

import KPIAlignment from "components/visuals/KPIAlignment";

import { useAppSelector } from "store";
import { selectRetailersAlignmentScore } from "modules/customer/tools/location/retailers/retailersSlice";
import { selectIsLoading, selectHasErrors, selectTarget } from "modules/customer/tools/location/locationSlice";

const OverallRetailersAlignmentScore: React.FC = () => {
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const retailersAlignmentScore = useAppSelector(selectRetailersAlignmentScore);
    const target = useAppSelector(selectTarget);

    const disabled = !(target?.useRetailers);
    const label = "Retailers alignment score";

    return (
        <Box width="100%" height="100%" data-cy="overall-retailers-alignment-score">
            <KPIAlignment
                isLoading={isLoading}
                hasErrors={hasErrors}
                label={label}
                score={retailersAlignmentScore}
                disabled={disabled}
            />
        </Box>
    );
};

export default OverallRetailersAlignmentScore;
